function sortCities(cityA, cityB) {
  const cityAPosition = cityA.position;
  const cityBPosition = cityB.position;
  if (cityAPosition !== void 0 && cityBPosition === void 0) {
    return -1;
  }
  if (cityAPosition === void 0 && cityBPosition !== void 0) {
    return 1;
  }
  if (cityAPosition === void 0 && cityBPosition === void 0 || cityAPosition === cityBPosition) {
    return cityA.name.localeCompare(cityB.name);
  }
  return (cityAPosition || 0) - (cityBPosition || 0);
}
export {
  sortCities
};
